export const REPORTS_MAIN_PATH = "/superset-reports";
